export default "__VITE_ASSET__dde24cc5__"